/* ══════════════════════════════════════════════════════════════════
   Was in einem Vorgang steckt — der Ersatz für einen leeren Betreff.

   **Seit dem 05.10.2026 hat ein Vorgang nur dann einen Betreff, wenn ein
   Mensch ihn eingetragen hat** (Luca, „ja mach"). Bis dahin setzten
   Vermieten und Merkliste den Namen der ersten Maschine hinein — und auf
   Angebot und Auftragsbestätigung stand über vier Positionen
   „MOSA Notstromaggregat GE 15 PSX".

   Damit Kopf und Liste ohne Betreff nicht leer aussehen, steht dort, was im
   Vorgang steckt: die Mietzeilen ohne ihr Zubehör, und gibt es keine Miete,
   die Leistungen und Waren. Dieselbe Regel wie `INHALT_O` in der API
   (`apps/api/src/dienste/vorgangsinhalt.ts`), hier für den Einzelsatz, der
   seine Positionen schon mitbringt. Nur Anzeige: Gespeichert wird nichts,
   und auf ein Papier geht es nicht.
   ══════════════════════════════════════════════════════════════════ */

/** Die Felder einer Position, wie `GET /vorgaenge/:id` sie liefert. */
export type Inhaltszeile = { kind?: unknown; label?: unknown; parent_item_id?: unknown };

const text = (w: unknown): string => (typeof w === "string" ? w.trim() : "");

/** „MOSA GE 15 · Fahrbahnplatte" — oder leer, wenn nichts darin steht. */
export function inhaltAusPositionen(positionen: readonly Inhaltszeile[]): string {
  const einmal = (liste: string[]) => [...new Set(liste.filter(Boolean))].join(" · ");
  const mieten = einmal(positionen
    .filter((p) => p.kind === "miete" && !text(p.parent_item_id))
    .map((p) => text(p.label)));
  if (mieten) return mieten;
  return einmal(positionen
    .filter((p) => p.kind === "leistung" || p.kind === "verkauf")
    .map((p) => text(p.label)));
}

/** Der Betreff, und ohne ihn der Inhalt. */
export function titelAus(betreff: string, inhalt: string): string {
  return betreff.trim() || inhalt.trim();
}
